import { array, string, node, object, number, arrayOf, shape } from 'prop-types'

export const defaultProps = {
	eventType: 'hover',
}

export const propTypes = {
	items: arrayOf(
		shape({
			id: number,
			title: node,
			type: string,
			url: string,
			children: array,
		})
	).isRequired,
	eventType: string.isRequired,
	additionalContent: node,
	dropDownProps: object,
}
